import { GameManager } from "../GameManager";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { Background } from "./Background";
import { AudioManager } from "../AudioManager";

declare var GZLOADER;
export class PreloadScene extends Phaser.Scene {

    public static currentInstance: PreloadScene;

    private progressBar: Phaser.GameObjects.Graphics;
    private scaledItemsContainer: Phaser.GameObjects.Container;

    constructor() {

        super("PreloadScene");

        PreloadScene.currentInstance = this;
    }

    public preload(): void {
        GZLOADER.modify(108, 100)
        this.composeScene();

        this.loadAssets();
    }

    public create(): void {

        GameManager.setCurrentScene(this);

        this.loadHowl();
    }
    
    private composeScene(): void {

        this.add.text(-50, 0, "abcdefghijk", { fontFamily: "Teko-Medium", fontSize: "22px", color: "#FFFFFF"});
        this.add.text(-50, 30, "abcdefghijk", { fontFamily: "Wolf-Sans-Regular", fontSize: "22px", color: "#FFFFFF"});
        this.add.text(-50, 60, "abcdefghijk", { fontFamily: "Montserrat-Black", fontSize: "22px", color: "#FFFFFF"});

        // const background = new Background(this, 0);
        // this.add.existing(background);

        // this.scaledItemsContainer = this.add.container(GameConstants.GAME_WIDTH / 2, 600);
        // this.scaledItemsContainer.scaleY = GameVars.scaleY;

        // const barWidth = 550;
        // const barWHeight = 18;
        // const borderWidth = 3;

        // const preloadBarCapsuleBorder = new Phaser.GameObjects.Graphics(this);
        // preloadBarCapsuleBorder.fillStyle(0x015e80);
        // preloadBarCapsuleBorder.fillRect(0, 0, barWidth + borderWidth * 2, barWHeight + borderWidth * 2);
        // preloadBarCapsuleBorder.x = - barWidth / 2 - borderWidth;
        // preloadBarCapsuleBorder.y = -borderWidth;
        // this.scaledItemsContainer.add(preloadBarCapsuleBorder); 

        // const preloadBarCapsule = new Phaser.GameObjects.Graphics(this);
        // preloadBarCapsule.fillStyle(0x555555);
        // preloadBarCapsule.fillRect(0, 0, barWidth, barWHeight);
        // preloadBarCapsule.x = - barWidth / 2;
        // this.scaledItemsContainer.add(preloadBarCapsule); 

        // this.progressBar = new Phaser.GameObjects.Graphics(this);
        // this.progressBar.fillStyle(0xFFFFFF);
        // this.progressBar.fillRect(0, 0, barWidth, barWHeight);
        // this.progressBar.x = - barWidth / 2;
        // this.progressBar.scaleX = 0;
        // this.scaledItemsContainer.add(this.progressBar); 
    }

    private loadAssets(): void {

        this.load.atlas("texture_atlas_1", "assets/texture_atlas_1_v2.png", "assets/texture_atlas_1_v2.json");
        this.load.atlas("texture_atlas_2", "assets/texture_atlas_2_v2.png", "assets/texture_atlas_2_v2.json");
        this.load.atlas("texture_atlas_3", "assets/texture_atlas_3_v2.png", "assets/texture_atlas_3_v2.json");
  
        this.load.json("game-text", "assets/config/game-text_v3.json");
        this.load.json("shop-items", "assets/config/shop-items.json");

        this.load.html("nameform", "assets/nameform.html");

        this.load.json("sound", "assets/audio/audiosprite.json");

        this.load.on("progress", this.updateLoadedPercentage, this);
    }

    private updateLoadedPercentage(percentageLoaded: number): void {
			GZLOADER.loadProcess((percentageLoaded * 0.95) * 100);
        // if (this.progressBar.scaleX < percentageLoaded) {
        //     this.progressBar.scaleX = percentageLoaded;
        // }
    }

    private loadHowl(): void {

        let soundJson = this.cache.json.get("sound");
        soundJson = JSON.parse(JSON.stringify(soundJson).replace("urls", "src"));

        AudioManager.sound = new Howl(soundJson);
    
        AudioManager.sound.on("load", function() {
          GZLOADER.loadProcess(100);
					GZLOADER.unload();	
            GameManager.onGameAssetsLoaded();
        });
    }
}
